module.exports = __webpack_public_path__ + "img/6.84318cb.png";